module.exports = __webpack_public_path__ + "img/tickets-unavailable.8f4ff781.svg";